<template>
    <div class="container">
        <menu-list></menu-list>
        <div class="main">
            <div class="main-content">
                <div class="main-left ">
                    <div class="product-wrap boxshadow2">
                        <div class="item">
                            <div class="product-img">
                                <img :src="productDefault.image" alt="">
                            </div>
                            <div class="product-attached">
                            <span v-for="(item,index) in productDefault.attachments" :key="`attached_${index}`">
                                <img v-if="index<6" :src="item" alt="" width="44px" height="44px">
                            </span>
                            </div>
                            <div class="product-price">
                                <span>${{productDefault.price}}</span>
                            </div>
                            <div class="product-title" :title="productDefault.title">
                                {{productDefault.title}}
                            </div>
                            <div class="product-comments">
                                <span>9888+ </span> comments
                            </div>
                            <div class="product-shop">
                                <span>
                                    {{productDefault.brand}}
                                    <i class="iconfont iconownbrand"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="main-right">
                    <div class="basics-section boxshadow2">
                        <div class="basics-section-main">
                            <div class="head">
                                <span class="head-1">图片编辑</span>
                                <span class="head-2">Picture Editing</span>
                            </div>
                            <div class="cont">
                                <div class="img-upload-wrap">
                                    <el-upload
                                            action="/student/product/images"
                                            class="avatar-uploader"
                                            :on-success="(response,file,fileList)=>{return handleMainAvatarSuccess(response,file,fileList)}"
                                            :show-file-list="false">
                                        <img v-if="product.image" :src="product.image" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                    <div class="upload-description">
                                        <span style="color: #E50011;font-weight: bolder;font-size: 18px">主图</span>
                                        <span>
                                        图片地址：
                                    </span>
                                        <span>
                                        <el-input placeholder="请输入内容" v-model="product.image"></el-input>
                                    </span>
                                    </div>
                                </div>
                                <div class="img-upload-wrap" v-for="(item,index) in product.attachments"
                                     :key="`upload_${index}`">
                                    <el-upload
                                            class="avatar-uploader"
                                            :show-file-list="false"
                                            :on-success="(response,file,fileList)=>{return handleAvatarSuccess(response,file,fileList,index)}"
                                            action="/student/product/images">
                                        <img v-if="item" :src="item" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                    <div class="upload-description">
                                        <div class="tit" style="">
                                            <span>附图</span>
                                            <span @click="product.attachments.splice(index,1)">删除</span>
                                        </div>
                                        <span>
                                        图片地址：
                                    </span>
                                        <span>
                                        <el-input placeholder="请输入内容" v-model="product.attachments[index]"></el-input>
                                    </span>
                                    </div>
                                </div>
                                <div class="add-new-avatar" @click="addNewAvatar">
                                    新增描述图
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-footer">
                <div class="btnn active" @click="$router.push('/MaritimeSilkRoad/baseEdit')">
                    上一步
                </div>
                <div class="btnn active" @click="next()">
                    下一步
                </div>
            </div>
        </div>
        <div class="foot">
            闽ICP备17025076号-2 <span style="margin: 0 20px"></span>©2017-{{new Date().getFullYear()}} All rights reserved.
        </div>
    </div>
</template>

<script>
    export default {
        name: "baseEdit",
        data() {
            return {
                add: {
                    tags: '',
                    keywords: '',
                },
                product: {}
            }
        },
        created() {
            this.product = JSON.parse(JSON.stringify(this.$store.state.template.edit))
        },
        computed:{
            productDefault:function () {
                return JSON.parse(JSON.stringify(this.$store.state.template.default))
            }
        },
        watch:{
            product:{
                handler:function (newv) {
                    this.$store.commit('setData',{setKey:'template.edit',value:newv})
                },
                deep:true
            }
        },
        methods: {
            addNewAvatar() {
                if(this.product.attachments.length >= 10){
                    this.$message.error('附图不能大于10张');
                    return false;
                }
                this.product.attachments.push('')
            },
            closeDig() {
                this.$router.push('/product')
            },
            handleMainAvatarSuccess(response){
                if(response.succeed && response.login){
                    this.product.image = response.path
                }
            },
            handleAvatarSuccess(response,file,fileList,index){
                if(response.succeed && response.login){
                    this.$set(this.product.attachments,index,response.path)
                }
            },
            next(){
                if(!this.product.image){
                    this.$message.error('请上传主图')
                    return false
                }
                if(!(this.product.attachments.length > 2)){
                    this.$message.error('产品的附图不能少于3张')
                    return false
                }
                this.$router.push('/MaritimeSilkRoad/priceEdit')
            }
        }
    }
</script>

<style scoped lang="scss">

    .main {
        div.main-content {
            display: flex;

            div.main-left {
                display: flex;
                flex-direction: column;
                margin-right: 28px;
                width: 452px;

                div.product-wrap {
                    background: #FFFFFF;
                    border-radius: 16px;

                    .item {
                        width: 388px;
                        height: 712px;
                        margin: 54px 32px;
                        border: 2px solid #adadad;
                        border-radius: 20px;
                        box-sizing: border-box;
                        padding: 24px;
                        /*background: #f5f5f5;*/
                        display: flex;
                        flex-direction: column;
                        position: relative;

                        > .product-img {
                            width: 100%;
                            height: 0;
                            padding-bottom: 100%;
                            overflow: hidden;
                            position: relative;

                            img {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                max-width: 100%;
                                height: 100%;
                            }
                        }

                        > .product-attached {
                            margin: 12px 0;
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;

                            span {
                                display: inherit;
                                width: 44px;
                                height: 44px;
                                margin-right: 12px;

                                > img {
                                    object-fit: cover;

                                    &:last-child {
                                        margin-right: 0;
                                    }
                                }
                            }
                        }

                        > .product-price {
                            font-size: 34px;
                            margin: 18px 0;
                            color: #E50011;

                        }

                        > .product-title {

                            font-size: 18px;
                            color: #595757;
                            text-overflow: ellipsis;
                            line-height: 20px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            margin-bottom: 18px;
                        }

                        > .product-comments {
                            font-size: 18px;
                            line-height: 20px;
                            color: #adadad;
                            margin: 18px 0;

                            > span {

                                font-weight: bolder;
                                color: #089BAB;
                            }
                        }

                        > .product-shop {
                            span {
                                display: flex;
                                align-items: center;
                                font-size: 18px;
                                line-height: 20px;
                                color: #adadad;

                                i {
                                    margin-left: 8px;
                                    font-size: 28px;
                                    color: #089BAB;
                                }
                            }
                        }

                    }
                }

                div.basics-section {
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    background: #FFFFFF;
                    border-radius: 16px;
                }
            }

            div.main-right {
                display: flex;
                flex-direction: column;
                flex-grow: 2;
            }
        }

    }

    .pagination-wrap {
        display: inline-block;

        > div.pagination {
            padding: 0 20px;
            height: 60px;
            background: #FFFFFF;
            border-radius: 10px;
            box-shadow: 3px 10px 20px -6px #b5cdd3;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
        }
    }

    div.main-footer {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-top: 30px;

        > div.btnn {
            box-shadow: 0px 10px 26px -10px #9E9E9E;
            cursor: pointer;
            background: #FF65A5;
            width: 100%;
            text-align: center;
            padding: 12px ;
            color: #FFFFFF;
            transition: all 0.3s linear;
            &:first-child {
                border-radius: 10px 0 0 10px;
                background: #ABD5DB;
            }

            &:last-child {
                border-radius: 0 10px 10px 0;
                background: #4149A9;
            }
            &:hover {
                transition: all 0.3s ease-in-out;
                box-shadow: 0px 10px 26px -10px #000;
            }
        }
    }

    div.foot {
        width: 100%;
        height: 30px;
        margin-top: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
        font-size: 14px;
        color: #ABD5DB;
    }
    ::v-deep .avatar-uploader .el-upload {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #089BAB;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #089BAB;
        width: 112px;
        height: 112px;
        line-height: 112px;
        text-align: center;
        border-radius: 10px;
    }

    .add-new-avatar {
        border: 1px dashed #089bab;
        cursor: pointer;
        text-align: center;
        color: #089bab;
        height: 60px;
        line-height: 60px;
        border-radius: 10px;
        transition: all 0.3s linear;

        &:hover {
            transition: all 0.3s linear;
            border-color: #FDAD53;
            color: #FDAD53;
        }
    }

    .avatar {
        border-radius: 10px;
        width: 112px;
        height: 112px;
        display: block;
    }
</style>
